export default __webpack_public_path__ + "static/media/bg-card-1-420.5f092fdf.jpg";